import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import showToast from '@/utils/helpers/show-toast';

const signInUser = async () => {
  const { data } = await axiosInstance.get(API_ROUTES.login());

  return data;
};

const showSignInErrorToast = (title: string) => {
  showToast({
    options: {
      duration: 3000,
      id: 'rate-limiter',
      classNames: {
        toast: '-mb-6!',
      },
    },
    variant: 'error',
    title: title,
  });
};

const useSignIn = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: signInUser,

    onSuccess: ({ redirectUrl }) => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        showSignInErrorToast(t('errors.auth.no_redirect'));
      }
    },

    onError: (error) => {
      if (isAxiosError(error)) {
        const status = error.response?.status;

        if (status === 429) {
          showSignInErrorToast(t('errors.auth.rate_limit'));
        } else if (status === 503 || !error.response) {
          showSignInErrorToast(t('errors.auth.server_unavailable'));
        } else {
          showSignInErrorToast(t('errors.auth.unexpected'));
        }
      } else {
        showSignInErrorToast(t('errors.auth.network'));
      }
    },
  });
};

export default useSignIn;
